import { OnAnimationFrame } from "../animation/OnAnimationFrame";
import { DOMHitTest } from "../dom-tools/DOMHitTest";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType} from "../dom-tools/ElementType";
import { LandscapeScale } from "../dom-tools/LandscapeScale";

export class SVGOverlay
{
  static readonly type = new ElementType( "svg--overlay" );
  static readonly docSelector = new ElementAttribute( "svg--doc-selector" );
  static readonly svgSelector = new ElementAttribute( "svg--selector" );

  static _addedListener = false;
  static _elements:Element[] = [];
  static _updateUntilMS:number = 0;
  static _updateDurationMS:number = 800;
  static _minimumFrames:number= 10;
  static _framesLeft:number = 0;

  static applyOnDocument( onAnimationFrame:OnAnimationFrame, landscapeScale:LandscapeScale )
  {
    this._addListener( onAnimationFrame, landscapeScale );
    this._elements = [];
    
    SVGOverlay.type.forAllInDoc( e => SVGOverlay.applyOnElement( e as HTMLElement ) );
    SVGOverlay.updateElements();
    
    SVGOverlay._updateUntilMS = new Date().getTime() + SVGOverlay._updateDurationMS;
    SVGOverlay._framesLeft = this._minimumFrames;

  }

  private static _addListener( onAnimationFrame:OnAnimationFrame, landscapeScale:LandscapeScale )
  {
    if ( this._addedListener ){ return; }
    this._addedListener = true;
    landscapeScale.onScreenSizeChange.addListener(
      ()=>
      {
        SVGOverlay._updateUntilMS = new Date().getTime() + SVGOverlay._updateDurationMS;
        SVGOverlay._framesLeft = this._minimumFrames;
        
      }
    )

    onAnimationFrame.addListener(
    ( ae )=>
    { 
      if ( SVGOverlay._framesLeft === 0 && ae.timeMS > SVGOverlay._updateUntilMS )
      {
        return;
      }
      
      if ( SVGOverlay._framesLeft > 0 )
      {
        SVGOverlay._framesLeft --;
      }

      SVGOverlay.updateElements();
    }
    );

  }

  static updateElements()
  {
    SVGOverlay._elements.forEach( s => SVGOverlay.updateElement( s ) );
  }

  static updateElement( e:Element )
  {
    let svgDoc = SVGOverlay.docSelector.queryValueInDoc( e );
    let offsetRect = DOMHitTest.getPageRect( e );

    SVGOverlay.svgSelector.forAll( 
      e, 
      svgOverlay =>
      {
        console.log( "svgOverlay", svgOverlay );

        let target = SVGOverlay.svgSelector.queryValueIn( svgOverlay, svgDoc ) as SVGGraphicsElement;
        let bounds = DOMHitTest.getPageRect( target );
        let centerX = bounds.left + bounds.width / 2;
        let centerY = bounds.top  + bounds.height / 2;


        let el = svgOverlay as HTMLElement;
        let elBounds = el.getBoundingClientRect();
        let x = ( centerX - elBounds.width / 2 - offsetRect.left ) +"px";
        let y = ( centerY - elBounds.height / 2 - offsetRect.top ) + "px";

        //el.style.left = `calc( ${x} / var(--spx-raw) )`;
        //el.style.top = `calc( ${y} / var(--spx-raw) )`; ;

        el.style.left = x;
        el.style.top = y;

        console.log( "SETTING POSITION", x, y, ">>>", el, )
      } 
    );
  }

  static applyOnElement( e:HTMLElement )
  {
    let svgDoc = SVGOverlay.docSelector.queryValueInDoc( e );

    if ( svgDoc == null )
    {
      return;
    }

    this._elements.push( e );
    
  }
}